import { render, staticRenderFns } from "./ProductSpecimen.vue?vue&type=template&id=4f453b2f"
import script from "./ProductSpecimen.vue?vue&type=script&lang=js"
export * from "./ProductSpecimen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports